import './Fixed.css';

const Fixed = ({children, extraClasses}) => {

  return (
    <div className={`${extraClasses} fixed`}>
        {children}
    </div>
  );
};

export default Fixed;
